<template>
  <div class="classify-card">
    <h2 class="classify-card-title" v-text="title"></h2>
    <van-divider style="margin:0 0;" />
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "ClassifyCard",
  props: {
    title: String
  }
};
</script>
<style scoped lang="scss">
.classify-card {
  margin-top: 7px;
  border-bottom:none;
}
.classify-card-title {
  padding: 5px 12px;
  color: #333;
  font-weight: normal;
  font-size: 22px;
}
</style>
